import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

const Tabs = ({ tabsCollection, pathname, handleOptionChoose }) => {
  const location = useLocation();
  const param = useParams();

  const renderOptions = (selOptions, index) => {
    let selectedPath = pathname;
    if (selOptions.selectedOption) {
      return (
        <option key={`${index}`} value={selOptions?.linkTarget} defaultValue>
          {selOptions.title}
        </option>
      );
    } else {
      return (
        <option key={`${index}`} value={selOptions?.linkTarget}>
          {selOptions.title}
        </option>
      );
    }
  };

  const renderTabs = (tabOption, index, handleOptionChoose) => {
    const handleClick = (event) => {
      event.preventDefault();
      handleOptionChoose(tabOption?.linkTarget);
    };
    if (!tabOption?.isShown) {
      return null;
    }
    return (
      <NavLink
        key={`${tabOption?.linkTarget}-${index}`}
        onClick={handleClick}
        className={`group inline-flex items-center gap-1 px-3 py-2 rounded-full text-sm font-medium transition-all
          ${tabOption?.selectedOption
            ? "bg-white text-blue-600"
            : "bg-transparent text-white border border-white/30 hover:bg-white/20"
          }`}
      >
        <svg
          className={`w-4 h-4 ${tabOption?.selectedOption ? "fill-blue-600" : "fill-white"}`}
          viewBox="0 0 20 20"
        >
          <path fillRule="evenodd" d={tabOption.icon} clipRule="evenodd" />
        </svg>
        <span className="ml-1">{tabOption.title}</span>
      </NavLink>
    );
  };

  return (
    <div>

      <div className="sm:hidden px-4">
        <select
          aria-label="Selected tab"
          className="mb-4 w-full font-normal px-3 py-2 h-11 rounded-lg focus:outline-none text-black border border-gray-300 focus:border-blue-400"
          defaultValue="summary"
          value={tabsCollection.find((i) => i.selectedOption)?.linkTarget || tabsCollection[0]?.linkTarget || ""}
          onChange={(e) => handleOptionChoose(e.target.value)}
        >
          {tabsCollection.map(renderOptions)}
        </select>
      </div>

      <div className="sm:block hidden">
      <div className="mb-6">
        <nav className="bg-gradient-to-r from-blue-600 to-cyan-500 rounded-2xl shadow-lg px-3 py-3 sm:px-4 sm:py-4 lg:px-6 lg:py-6">
          <div className="flex flex-wrap gap-2">
            {tabsCollection.map((e, indx) => renderTabs(e, indx, handleOptionChoose))}
          </div>
        </nav>
      </div>
    </div>
    </div>
  );
};

export default Tabs;
